import React from "react";
import axios from "axios";
import { Col, Container, Row } from "react-bootstrap";
import { AiFillWindows } from "react-icons/ai";
import { Link } from "react-router-dom";
import "./hero.css";
const link =
  "https://drive.google.com/uc?id=11t7XtwoaZYg6sjtq_DkH1Qo6FR4TGqWm&export=download";

const Hero = () => {
  const handleDownload = () => {
    window.open(link, "_blank");
    captureTotalDownloads();
  };

  const captureTotalDownloads = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/downloads`);
  };

  return (
    <Container id="home" className="hero__container py-5" fluid>
      <Row className="hero__row">
        <Col className="hero__col mb-5">
          <h1 className="hero__title">PDF-Toolkit</h1>
          <div className="hero__button mt-5" onClick={handleDownload}>
            <AiFillWindows size={35} />
            <p className="ms-3 mb-0">Download for Windows</p>
          </div>
          <p className="hero__instruction mt-2 mb-5 fw-bolder">
            Important: Please follow the installation instruction. Click{" "}
            <Link
              to="/instructions"
              className="text-danger hero_instruction--link"
            >
              here
            </Link>{" "}
            to see the instruction.
          </p>
        </Col>
      </Row>
      <Row className="hero__image-row mb-5">
        <Col className="hero__col">
          <img className="hero__img" src="/assets/images/main.png" alt="logo" />
        </Col>
      </Row>
    </Container>
  );
};

export default Hero;
